import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchToast,
  fetchToastSuccess,
  fetchToastFailure,
} from "../slices/toastSlice";

function* fetchToastSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/toast`,
    );

    const result = yield response.json();

    yield put(fetchToastSuccess(result)); // ✅ RAW DATA ONLY
  } catch (error) {
    yield put(fetchToastFailure(error.message));
  }
}

export function* watchToast() {
  yield takeLatest(fetchToast.type, fetchToastSaga);
}
